import styled from 'styled-components';

export const StyledSafetyTrainingLists = styled.div`
  .filterWrapper {
    display: flex;
    padding: 15px 0px;

    form {
      display: flex;

      > div {
        display: flex;
        align-items: center;

        > * {
          margin: 0px 5px;
          display: flex;
          align-items: center;
          white-space: nowrap;
        }
      }
    }
  }

  .buttonWrapper {
    button {
      margin: 0 6px;
    }
  }
`;

export const StyledStatusBox = styled.div`
  display: flex;
  justify-content: center;

  &.OnGoing {
    > span {
      background: #cf2e42;
    }
  }

  > span {
    display: flex;
    width: 106px;
    height: 28px;
    padding: 3px 0px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 4px;
    background: #6db983;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;
